import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import {
    Box, Divider, Text, Flex
} from 'components/ui';
import { colors } from 'style/config';
import Paypal from 'components/FrictionlessCheckout/PaymentReleaseFour/PaymentMethodList/Paypal/Paypal';
import Klarna from 'components/FrictionlessCheckout/PaymentReleaseFour/PaymentMethodList/Klarna/Klarna';
import { AfterPayPill } from 'components/FrictionlessCheckout/PaymentReleaseFour/PaymentMethodList/AfterPay';

const AlternatePaymentButtons = ({
    isAfterpayEnabledForThisOrder,
    isKlarnaEnabledForThisOrder,
    isPayPalEnabled,
    isPayPalPayLaterEligible,
    isAfterpayEnabledForThisProfile,
    installmentValue,
    localization,
    handleAfterPayExpand,
    handleKlarnaExpand,
    handlePayPalClick
}) => {
    // PayPal button only shows when enabled AND order >= $30 (isPayPalPayLaterEligible)
    // For orders < $30, PayPal is hidden on L1 (existing users with saved cards)
    const showPayPal = isPayPalEnabled && isPayPalPayLaterEligible;

    // Show installment text if any installment payment method is available
    const showInstallmentText = isPayPalPayLaterEligible || isKlarnaEnabledForThisOrder || isAfterpayEnabledForThisOrder;

    return (
        <Box>
            <Divider marginY={4} />
            <Box paddingX={5}>
                {showInstallmentText && (
                    <Text
                        is='p'
                        color={colors.gray}
                        marginBottom={1}
                        fontSize='sm'
                    >
                        {`${localization.orPayInFour} ${installmentValue}`}
                    </Text>
                )}

                {/* Payment buttons */}
                <Flex
                    gap={2}
                    marginBottom={4}
                >
                    <Paypal
                        isPayPalEnabled={showPayPal}
                        handlePaymentClick={handlePayPalClick}
                        height={32}
                        width={98}
                        imageScale={1.5}
                    />
                    <Klarna
                        isKlarnaEnabledForThisOrder={isKlarnaEnabledForThisOrder}
                        handlePaymentClick={handleKlarnaExpand}
                        height={32}
                        width={showPayPal ? 98 : 151}
                    />
                    <AfterPayPill
                        isAfterpayEnabledForThisOrder={isAfterpayEnabledForThisOrder}
                        isAfterpayEnabledForThisProfile={isAfterpayEnabledForThisProfile}
                        handleAfterPayExpand={handleAfterPayExpand}
                        height={32}
                        width={showPayPal ? 98 : 151}
                        imageHeight={16}
                    />
                </Flex>
            </Box>
        </Box>
    );
};

export default wrapFunctionalComponent(AlternatePaymentButtons, 'AlternatePaymentButtons');
